/*
 * @Description: 功能描述
 * @Author: yy
 * @Date: 2019-05-31 14:47:27
 * @LastEditors: yy
 * @LastEditTime: 2019-09-03 14:58:44
 */

import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './AdminAccountInfo.css';
import Calendar from '../../components/Calendar'
import Link from '../../components/Link'
import AdminBackNav from '../adminBackNav/adminBackNav';

const typeList=[
  {
    class:'试用账号',
    type:1
  },{
    class:'正式账号',
    type:2
  },{
    class:'管理员',
    type:3
  }
]

const tableTit=[

  {
    type:'id',
    class:'ID'
  },{
    type:'name',
    class:'姓名'
  },{
    type:'phone',
    class:'手机'
  },{
    type:'email',
    class:'邮箱'
  },{
    type:'brand',
    class:'品牌'
  },{
    type:'job',
    class:'职位'
  },{
    type:'timeStart',
    class:'注册时间'
  },
  {
    type:'timeEnd',
    class:'到期时间'
  },{
    type:'type',
    class:'账号类型'
  },{
    type:'note',
    class:'备注'
  }
]

class AdminAccountInfo extends React.Component {
  
  constructor(){
    super()
    this.state={
      accountType:0,
      note:'',
      timeEnd:null,
      data:[],
      accountTypeChange:false,
      noteChange:false,
      id:'',
      timeEndChange:false
    }
    this.isCalendarCon=false

    this.saveToState=this.saveToState.bind(this)
    this.saveFile=this.saveFile.bind(this)
    this.enCalendarCon=this.enCalendarCon.bind(this)
    this.ovCalendarCon=this.ovCalendarCon.bind(this)
    this.closeCalendarStart=this.closeCalendarStart.bind(this)
    this.closeCalendarEnd=this.closeCalendarEnd.bind(this)
    
  }
  closeCalendarStart=(time)=>{
    this.setState({timeStart:time,timeStartShow:false})
  }
  closeCalendarEnd=(time)=>{
    this.setState({timeEnd:time,timeEndShow:false})
  }
  
  enCalendarCon=()=>{
    this.isCalendarCon=true
  }
  ovCalendarCon=()=>{
    this.isCalendarCon=false
  }

  saveFile=()=>{
    // 保存数据到本地
    console.log(1)
  }
  getQueryString(name) {   
    var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");   
    var r = window.location.search.substr(1).match(reg);   
    if (r != null) return decodeURI(r[2]); return null;   
  }  
  componentDidMount() {
    let seaId=this.getQueryString('id')
    this.getAccountInfo(seaId)
    console.log(seaId)
  }

  saveToState=(e)=>{
    const {name,value}=e.target
    this.setState({
      [name]:value,
      
    })
  }
  getAccountInfo=(seaId)=>{
    const {note,accountType,timeEnd}=this.state
    this.setState({id:seaId})
    // const url=`/getAccountList?registerStart=${timeStart}&registerEnd=${timeEnd}&type=${accountType}&phone=${phone}&email=${email}&name=${name}&brand=${brandName}`
    const url=`/dbrankCMS/getAccountInfo?id=${seaId}`

    const myInit = {
      method: 'GET',
      credentials: 'include', 
      mode: 'cors',
      cache: 'no-cache' 
    };
    fetch(url,myInit)
    .then(response=>response.json())
    .then(data=>{
      console.log(data,'data')

      this.setState({
        data:data
      })

      if(data.errorCode==2){
        alert('请重新登录！')
      }

    })
    .catch(e=>{
      console.log('err',e)
    })




  


  }
 
  renderType=(type)=>{

    if(type in typeList){
      return typeList[type].class
    }

    // if(type==1){
    //   aType='试用'
    // }else if(type==2){
    //   aType='正式'
      
    // }else{
    //   aType='管理员'
    // }
    // return aType
  }


  doChangeAccountType=()=>{
    //更改账号信息

    this.setState({accountTypeChange:false})
    const {accountType,data}=this.state
    let aa
    
    if(accountType=='试用账号'){
      aa=1
    }else if(accountType=='正式账号'){
      aa=2
    }else if(accountType=='管理员'){
      aa=3
    }
    const url=`/dbrankCMS/doChangeAccountInfo?id=${data.id}&type=${aa}`
    // const url=`http://10.0.58.22:8082/doChangeAccountInfo?id=${data.id}&type=${aa}`

    const myInit = {
      method: 'GET',
      credentials: 'include', 
      mode: 'cors',
      cache: 'no-cache' 
    };
    fetch(url,myInit)
    .then(response=>response.json())
    .then(data=>{
      console.log(data,'data')

      if(data.errorCode==0){
        alert('修改成功！')
        this.getAccountInfo(this.state.id)
        
      }else if(data.errorCode==1){
        alert('修改失败！')
      }else if(data.errorCode==2){
        alert('请重新登录')
      }else if(data.errorCode==3){
        alert('没有修改权限')
      }
    })
    .catch(e=>{
      console.log('err',e)
    })
  }
  doChangeNote=()=>{
    //更改备注信息
    this.setState({noteChange:false})
    const {note,data,id}=this.state
    console.log(note)
    const url=`/dbrankCMS/doChangeAccountInfo?id=${data.id}&note=${note}`
    // const url=`http://10.0.58.22:8082/doChangeAccountInfo?id=${data.id}&note=${note}`
    // fetch(url,{

    //   method:'POST',
    //   headers:{
    //     'Content-Type':'application/json'
    //   },
    //   body:JSON.stringify({
    //     id:seaId          
    //   })
    
    // })
    const myInit = {
      method: 'GET',
      credentials: 'include', 
      mode: 'cors',
      cache: 'no-cache' 
    };
    fetch(url,myInit)
    .then(response=>response.json())
    .then(data=>{
      console.log(data,'data')
      if(data.errorCode==0){
        alert('修改成功！')
        this.getAccountInfo(this.state.id)
        
      }else if(data.errorCode==1){
        alert('修改失败！')
      }else if(data.errorCode==2){
        alert('请重新登录')
      }else if(data.errorCode==3){
        alert('没有修改权限')
      }
    
    })
    .catch(e=>{
      console.log('err',e)
    })
    
  }

  doChangeTimeEnd=()=>{
    //更改到期时间
    this.setState({timeEndChange:false})
    const {timeEnd,data}=this.state
    const url=`/dbrankCMS/doChangeAccountInfo?id=${data.id}&timeEnd=${timeEnd}`
    // const url=`http://10.0.58.22:8082/doChangeAccountInfo?id=${data.id}&timeEnd=${timeEnd}`
    // fetch(url,{

    //   method:'POST',
    //   headers:{
    //     'Content-Type':'application/json'
    //   },
    //   body:JSON.stringify({
    //     id:seaId          
    //   })
    
    // })
    const myInit = {
      method: 'GET',
      credentials: 'include', 
      mode: 'cors',
      cache: 'no-cache' 
    };
    fetch(url,myInit)
    .then(response=>response.json())
    .then(data=>{
      console.log(data,'data')

      if(data.errorCode==0){
        alert('修改成功！')
        this.getAccountInfo(this.state.id)
        
      }else if(data.errorCode==1){
        alert('修改失败！')
      }else if(data.errorCode==2){
        alert('请重新登录')
      }else if(data.errorCode==3){
        alert('没有修改权限')
      }
    })
    .catch(e=>{
      console.log('err',e)
    })
  }



  render() {
    const {accountType,timeEnd,timeStartShow,timeEndShow,note,data,accountTypeChange,timeEndChange,noteChange}=this.state
    // let aType
    return (
      <div className={s.root}>
        <AdminBackNav />
        
        <div className={s.container}>
          <h1>账号详情</h1>
          <div className={s.listBox}>
            <ul>
              {tableTit.map((i,index)=>{
                if(index<7){
                  return(
                    <li key={index}>
                      <span>{i.class}</span>
                      <em>{i.type=='type'?((data[i.type] in typeList)?typeList[data[i.type]].class:data[i.type]):data[i.type]}</em>
                    </li>
                  )
                }else{
                  return null
                }

              })}
              
              <li>
                <label>到期时间</label>
                {!timeEndChange?
                  <span>{data['timeEnd']}</span>
                :
                <li>

                <div className={s.timeItem} onBlur={()=>!this.isCalendarCon?this.setState({timeEndShow:false}):null}  tabIndex='0'>
                  <div className={s.month} onClick={()=>this.setState({timeEndShow:!this.state.timeEndShow})}>
                      <span className={s.monthTxt} >{timeEnd}</span>
                  </div>
                      
                      <Calendar  isShow={timeEndShow} close={this.closeCalendarEnd} cycle='日榜'
                          en={this.enCalendarCon}  hasMore={true} ov={this.ovCalendarCon} otherlayout={true}
                      />
                </div>
                </li>
                
                }
                {
                  !timeEndChange?
                  <span onClick={()=>this.setState({timeEndChange:true,timeEnd:data['timeEnd']})}>修改</span>
                  :<li>
                    <span onClick={this.doChangeTimeEnd}>确认</span>
                    <span onClick={()=>this.setState({timeEndChange:false})}>取消</span>
                  </li>
                }
              </li>
              <li>
                <label>账号类型</label>
                {!accountTypeChange?
                  <span>{data['type']}</span>
                :
                <select value={accountType} onChange={(e)=>this.setState({accountType:e.target.value})}>
                  {typeList.map(i=><option key={i.type} value={i.class}>{i.class}</option>)}
                </select>
                }
                {
                  !accountTypeChange?
                  <span onClick={()=>this.setState({accountTypeChange:true,accountType:data['type']})}>修改</span>
                  :<div>
                    <span onClick={this.doChangeAccountType}>确认</span>
                    <span onClick={()=>this.setState({accountTypeChange:false})}>取消</span>
                  </div>
                }
              </li>
              <li>
                <label>备注</label>
                {!noteChange?
                <span>{data['note']}</span>
                :<input name='note' value={note} onChange={this.saveToState} />
                }
                {
                  !noteChange?
                  <span onClick={()=>this.setState({noteChange:true,note:data['note']})}>修改</span>
                  :<div>
                    <span onClick={this.doChangeNote}>确认</span>
                    <span onClick={()=>this.setState({noteChange:false})}>取消</span>
                  </div>
                }
              </li>
              {/* <li>
                <span>{i.class}</span>
              </li> */}
{/*               
              <li>
                <div className={s.timeItem} onBlur={()=>!this.isCalendarCon?this.setState({timeStartShow:false}):null}  tabIndex='0'>
                  <span className={s.timeInfoTxt}>发布时间：</span>
                  <div className={s.month} onClick={()=>this.setState({timeStartShow:!this.state.timeStartShow})}>
                      <span className={s.monthTxt} >{timeStart}</span>
                      <Calendar  isShow={timeStartShow} close={this.closeCalendarStart} cycle='日榜'
                          en={this.enCalendarCon}   ov={this.ovCalendarCon} otherlayout={true}
                      />
                  </div>
                </div>
                <div className={s.timeItem} onBlur={()=>!this.isCalendarCon?this.setState({timeEndShow:false}):null}  tabIndex='0'>
                  <span className={s.timeInfoTxt}>结束时间：</span>
                  <div className={s.month} onClick={()=>this.setState({timeEndShow:!this.state.timeEndShow})}>
                      <span className={s.monthTxt} >{timeEnd}</span>
                      <Calendar  isShow={timeEndShow} close={this.closeCalendarEnd} cycle='日榜'
                          en={this.enCalendarCon}   ov={this.ovCalendarCon} otherlayout={true}
                      />
                  </div>
                </div>
              </li>
              <li>
                
                <label>账号类型：</label>
                  <select onChange={(e)=>this.setState({accountType:e.target.value})}
                    value={accountType}>
                    {typeList.map(i=>
                      <option key={i.type} value={i.type}>{i.class}</option>
                    )}
                  </select>
              </li> */}

            </ul>
            {/* <div onClick={this.getAccountInfo}>搜索</div> */}
          </div>
          
        </div>
        
      </div>
    );
  }
}

export default withStyles(s)(AdminAccountInfo);



// WEBPACK FOOTER //
// src/routes/adminAccountInfo/AdminAccountInfo.js